var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Add-User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33235 6.8508L4.39786 6.85082L4.54304 6.85121C5.77611 6.85781 8.6647 6.96989 8.6647 8.87535C8.6647 10.642 6.29233 10.8781 4.44697 10.887L4.12166 10.8868C2.88859 10.8802 0 10.7682 0 8.86325C0 7.05925 2.47225 6.8508 4.33235 6.8508ZM4.33235 7.6758C2.0053 7.6758 0.825 8.07565 0.825 8.86325C0.825 9.65855 2.0053 10.0623 4.33235 10.0623C6.6594 10.0623 7.8397 9.6624 7.8397 8.87535C7.8397 8.07895 6.6594 7.6758 4.33235 7.6758ZM9.46226 3.25529C9.68996 3.25529 9.87476 3.44009 9.87476 3.66779L9.8747 4.35765L10.5875 4.35809C10.8152 4.35809 11 4.54289 11 4.77059C11 4.99829 10.8152 5.18309 10.5875 5.18309L9.8747 5.18265L9.87476 5.87384C9.87476 6.10154 9.68996 6.28634 9.46226 6.28634C9.23456 6.28634 9.04976 6.10154 9.04976 5.87384L9.0497 5.18265L8.338 5.18309C8.1103 5.18309 7.9255 4.99829 7.9255 4.77059C7.9255 4.54289 8.1103 4.35809 8.338 4.35809L9.0497 4.35765L9.04976 3.66779C9.04976 3.44009 9.23456 3.25529 9.46226 3.25529ZM4.33235 0C5.9455 0 7.25725 1.3123 7.25725 2.9249C7.25725 4.5375 5.9455 5.8498 4.33235 5.8498H4.3153C3.53485 5.84705 2.80335 5.5407 2.255 4.9885C1.7061 4.43575 1.40525 3.70205 1.40798 2.92325C1.40798 1.3123 2.71975 0 4.33235 0ZM4.33235 0.825C3.17515 0.825 2.23298 1.76715 2.23298 2.9249C2.2308 3.48535 2.4464 4.0106 2.83965 4.40715C3.23345 4.80315 3.75815 5.0226 4.31695 5.0248L4.33235 5.43235V5.0248C5.4901 5.0248 6.43225 4.08265 6.43225 2.9249C6.43225 1.76715 5.4901 0.825 4.33235 0.825Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserBlack);
export default __webpack_public_path__ + "static/media/Add-UserBlack.0f68354def9b8b1c75e7b6929ad68b58.svg";
export { ForwardRef as ReactComponent };